import React from 'react';

export default class Top extends React.Component {
    // <div class="px-6 py-6"><div class="logo"></div></div>
    render() {
        return (
            <div class="flex max-w-full bg-gray-300 relative container topbgimg">
                <ul class="pl-64 pr-64 flex text-center absolute bottom-0 p-2 min-w-full md:pl-12 md:pr-12 sm:p-0">
                    <li class="p-2 w-1/3">
                        <a class="hover:text-blue-800" href="#drink">推薦飲品</a>
                    </li>
                    <li class="p-2 w-1/3">
                        <a class="hover:text-blue-800" href="https://line.me/R/ti/p/Ndtea3GYpS">馬上訂購</a>
                    </li>
                    <li class="p-2 w-1/3">
                        <a class="hover:text-blue-800" href="#context">聯絡我們</a>
                    </li>
                </ul>
            </div>
        )
    }
}